import {
  AfterViewInit,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { AranDrawerModalService } from '@aran-client/aran-web-ui-toolkit';
import { Store } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { appInfo } from 'src/app/shared/constants/app-info.constant';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';
import { statusStylesWithColor } from 'src/app/shared/constants/status-color.constant';
import { RequestStatus } from 'src/app/shared/enums/status.enum';
import { StoreHelperService } from 'src/app/shared/services/store-helper/store-helper.service';
import * as requestTypes from 'src/app/shared/types/requests.types';
import { RequestsAction } from 'src/app/store/requests/requests.action';
import { RequestsState } from 'src/app/store/requests/requests.state';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss'],
})
export class RequestsComponent implements OnInit, AfterViewInit {
  @ViewChild('createNewRequest') createNewRequest!: TemplateRef<any>;
  @ViewChild('updateRequest') updateRequest!: TemplateRef<any>;
  @ViewChild('statusTemplate', { static: true }) statusTemplate!: any;

  routeMetaData = routeMetaData;
  appInfo = appInfo;

  currentPage: number = 1;
  itemsPerPage: number = 10;

  menuItems: any[] = [];
  columns: any[] = [];

  currentTemplate!: TemplateRef<any>;
  modalTitle: string = '';
  searchText = new FormControl('');

  isLoading$: Observable<boolean> = this.store.select(
    RequestsState.getIsLoading()
  );

  public selectedElement!: requestTypes.Requests;

  dataSource: requestTypes.Requests[] = [];

  constructor(
    private store: Store,
    private aranDrawerModalService: AranDrawerModalService,
    private storeHelperService: StoreHelperService
  ) { }

  ngOnInit(): void {
    this.getRequestList();
  }

  ngAfterViewInit() {
    this.columns = [
      {
        columnDef: 'creationDate',
        header: 'Request Date',
        cell: (element: requestTypes.Requests) => `${element.creationDate}`,
      },
      {
        columnDef: 'status',
        header: 'Status',
        cellTemplate: this.statusTemplate,
      },
      {
        columnDef: 'Actions',
        header: 'Action',
      },
    ];
  }

  getRequestList() {
    this.storeHelperService
      .getAllDispatchAndSelect(
        new RequestsAction.GetRequests(),
        RequestsState.getRequestsList,
        { takeOne: false }
      )
      .pipe(
        tap((data) => {
          this.dataSource = data?.data || [];
        })
      )
      .subscribe();
  }

  openDialog = () => {
    this.modalTitle = 'Make New Service Request';
    this.currentTemplate = this.createNewRequest;
    this.aranDrawerModalService.show();
  };

  update() {
    this.modalTitle = 'Update Service Request';
    this.currentTemplate = this.updateRequest;
    this.aranDrawerModalService.show();
  }

  delete(id:number): void {
   
  this.storeHelperService
    .getAllDispatchAndSelect(new RequestsAction.DeleteRequest(id))
    .pipe(
      tap(() => {
        this.getRequestList();
      })
    )
    .subscribe();
  }

  resetFilter() {
    this.searchText.reset('');
  }

  onSelectRow(selectedElement: any) {
    this.selectedElement = selectedElement;

    this.menuItems = [
      {
        isVisible: true,
        name: 'View',
        icon: 'visibility',
        iconType: 'material',
        type: 'link',
        routerLink: [routeMetaData.requests.link, selectedElement.id],
        target: '_self',
      },
      {
        isVisible: selectedElement && selectedElement.status === 'Pending',
        name: 'Edit',
        icon: 'edit',
        iconType: 'material',
        type: 'action',
        action: () => this.update(),
      },
      {
        isVisible: selectedElement && selectedElement.status === 'Pending',
        name: 'Delete',
        icon: 'delete',
        iconType: 'material',
        type: 'action',
        redHoverColor: true,
        action: () => this.delete(selectedElement.id),
      },
    ];
  }

  getStatusColor(status: string): string {
    return statusStylesWithColor[status as RequestStatus];
  }
}
